import { render, staticRenderFns } from "./SignAbyPower.vue?vue&type=template&id=0c19b1ec&scoped=true&"
import script from "./SignAbyPower.vue?vue&type=script&lang=js&"
export * from "./SignAbyPower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19b1ec",
  null
  
)

export default component.exports